<script lang="ts" setup>
import { computed } from 'vue';

import PatientAvatar from '@/components/PatientAvatar.vue';
import type { ChatPatientMessage } from '@sigma/chat-common/ChatEvent.js';
import { defineChatEventProps } from '@sigma/client/chat/defineChatEventProps.js';
import ChatEventWrapper from '@sigma/ui/chat/ChatEventWrapper.vue';
import ChatFiles from '@sigma/ui/chat/ChatFiles.vue';
import ChatMessage from '@sigma/ui/chat/ChatMessage.vue';

import chatCss from './chat.module.scss';

const props = defineProps(defineChatEventProps<ChatPatientMessage>());

const isFirst = computed(() => {
  const previousEvent = props.chat.events[props.event.seq - 1];
  return previousEvent?.type !== 'PATIENT_MESSAGE' && previousEvent?.type !== 'PATIENT_FORM';
});
const isLast = computed(() => {
  const nextEvent = props.chat.events[props.event.seq + 1];
  return nextEvent?.type !== 'PATIENT_MESSAGE' && nextEvent?.type !== 'PATIENT_FORM';
});
</script>

<template>
  <ChatEventWrapper
    tid="patient-message"
    :event="event"
    :class="chatCss.container"
  >
    <ChatMessage
      color="blue"
      align="right"
      :is-first="isFirst"
      :is-last="isLast"
      :timestamp="event.timestamp"
    >
      <template #avatar>
        <PatientAvatar />
      </template>

      <template
        v-if="event.files?.length"
        #top
      >
        <ChatFiles
          :files="event.files"
          color="blue"
        />
      </template>

      <template #content>
        {{ event.content }}
      </template>
    </ChatMessage>
  </ChatEventWrapper>
</template>
